export type AppErrorKind = 'network' | 'http' | 'auth' | 'validation' | 'business' | 'unknown';

export interface AppErrorOptions {
  kind: AppErrorKind;
  /** Safe, PII-free message shown to the user. */
  messageForUser: string;
  status?: number;
  code?: string;
  cause?: unknown;
}

/** The single error shape the UI ever sees. Raw backend errors never leak past here. */
export class AppError extends Error {
  readonly kind: AppErrorKind;
  readonly messageForUser: string;
  readonly status?: number;
  readonly code?: string;

  constructor(options: AppErrorOptions) {
    super(
      options.messageForUser,
      options.cause !== undefined ? { cause: options.cause } : undefined,
    );
    this.name = 'AppError';
    this.kind = options.kind;
    this.messageForUser = options.messageForUser;
    if (options.status !== undefined) this.status = options.status;
    if (options.code !== undefined) this.code = options.code;
  }
}
